import {Component, OnInit} from '@angular/core';
import {BlacklistService} from '../../../../services/blacklist/blacklist.service';
import {FormBuilder, Validators} from '@angular/forms';
import {UiAlertService} from '../../../../services/ui-alert/ui-alert.service';

@Component({
  selector: 'app-superadmin-users-blacklist',
  templateUrl: './superadmin-users-blacklist.component.html',
  styleUrls: ['./superadmin-users-blacklist.component.scss'],
})
export class SuperadminUsersBlacklistComponent implements OnInit {
  public blacklist: any[] = [];
  public blacklistAll: any[] = [];
  public today = new Date();
  public blacklistSearch = '';

  public resourceTypes = [
    { label: 'Username', value: 'userPassword', placeholder: 'username' },
    { label: 'Facebook ID', value: 'facebookId', placeholder: '1231548471547' },
    { label: 'Phone Number', value: 'phoneNumber', placeholder: '12223334444' },
    { label: 'User ID', value: 'userId', placeholder: 'user-id' },
    { label: 'Instagram ID', value: 'instagramId', placeholder: '221348674231' },
    { label: 'Family ID', value: 'family', placeholder: 'family-id' },
  ];

  public form = this.formBuilder.group({
    description: [''],
    resourceType: [null as any, Validators.required],
    resourceId: ['', Validators.required],
  });

  constructor(
    private blacklistService: BlacklistService,
    private formBuilder: FormBuilder,
    private uiAlertService: UiAlertService,
  ) {}

  ngOnInit(): void {
    this.load();
  }

  async load(): Promise<void> {
    try {
      const data = await this.blacklistService.list();
      this.blacklist = data || [];
      this.blacklistAll = JSON.parse(JSON.stringify(this.blacklist));
      this.form.reset({ description: '', resourceType: null, resourceId: '' });
    } catch (error) {
      console.error('Error loading blacklist', error);
    }
  }

  async remove(item: any): Promise<void> {
    const confirm = await this.uiAlertService.presentAlertConfirm('Remove this resource from blacklist?');
    if (!confirm) {
      return;
    }
    try {
      await this.blacklistService.remove(item.resourceType, item.resourceId);
      await this.load();
    } catch (error) {
      console.error('Error removing blacklist item', error);
    }
  }

  async add(): Promise<void> {
    if (this.form.invalid) {
      return;
    }
    const formValue = this.form.value;
    const data = {
      description: formValue.description,
      resourceType: formValue.resourceType?.value || formValue.resourceType,
      resourceId: formValue.resourceId,
    };
    try {
      await this.blacklistService.create(data);
      await this.load();
    } catch (error: any) {
      if (error?.data?.errors?.code === 'ER_DUP_ENTRY') {
        console.error('Resource already created');
      } else {
        console.error('Error adding blacklist item', error);
      }
    }
  }

  onInput(): void {
    if (this.blacklistSearch) {
      this.blacklist = this.blacklistAll.filter((item) => {
        return (
          item.resourceType?.indexOf(this.blacklistSearch) >= 0 ||
          item.resourceId?.indexOf(this.blacklistSearch) >= 0
        );
      });
    } else {
      this.blacklist = JSON.parse(JSON.stringify(this.blacklistAll));
    }
  }

  resourcePlaceholder(): string {
    const value: any = this.form.get('resourceType')?.value;
    return value?.placeholder || '';
  }
}
